import { computed } from "vue";
import addressFormat from "@/utils/addressFormat";
export function usePrizeMoneyPayoutContactHelpers(props) {
    const showMainDetails = computed(() => {
        return !!(name.value || code.value || props.contact.registryCountryId);
    });
    const code = computed(() => {
        switch (props.contact.contactType) {
            case "PERSON":
                return props.contact.registryCode;
            case "ORGANISATION":
                return props.contact.vatCode || props.contact.registryCode;
            default:
                return "";
        }
    });
    const name = computed(() => {
        if (props.contact.name)
            return props.contact.name;
        switch (props.contact.contactType) {
            case "PERSON": {
                if (props.contact.firstName && props.contact.lastName) {
                    return props.contact.firstName + " " + props.contact.lastName;
                }
                return "";
            }
            case "ORGANISATION":
                return props.contact.organisationName;
            default:
                return "";
        }
    });
    const iban = computed(() => {
        return [props.contact.iban, props.contact.swiftBicCode]
            .filter(Boolean)
            .join(" | ");
    });
    const addressContactFormat = computed(() => {
        return addressFormat({
            address: props.contact.addressText,
            houseNumber: props.contact.addressHouse,
            index: props.contact.addressIndex,
            box: props.contact.addressBox,
            city: props.contact.addressCity,
            state: props.contact.addressState,
            country: props.contact.addressCountry?.name
        });
    });
    const showAdditionals = computed(() => {
        return (props.contact.contactType == "PERSON" &&
            !!(props.contact.incomeTaxPercentage != null ||
                (!props.contact.incomeTaxCardFileRemove &&
                    (props.contact.incomeTaxCardFilePath ||
                        props.contact.incomeTaxCardFile))));
    });
    return {
        iban,
        showMainDetails,
        code,
        name,
        addressContactFormat,
        showAdditionals
    };
}
